import React from 'react';
import PropTypes from 'prop-types';

export default function Loader(props) {
    const { active, dim, transparent, ...rest } = props;
    let classes = '';

    if (active) {
        classes += 'user_blocking_container loading ';
    }

    if (transparent) {
        classes += 'transparent ';
    }

    if (dim) {
        classes += 'dim ';
    }

    if (active) {
        return (
            <div className={classes} {...rest}>
                <div className="custom_loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        )
    }

    return null;
}

Loader.propTypes = {
    active: PropTypes.bool,
    dim: PropTypes.bool,
    transparent: PropTypes.bool,
}
